// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AckAlarmRequest,
    AckAlarmRequestFromJSON,
    AckAlarmRequestToJSON,
} from '../models/AckAlarmRequest';
import {
    type AlarmMonitorSettings,
    AlarmMonitorSettingsFromJSON,
    AlarmMonitorSettingsToJSON,
} from '../models/AlarmMonitorSettings';
import {
    type ConfirmAlarmRequest,
    ConfirmAlarmRequestFromJSON,
    ConfirmAlarmRequestToJSON,
} from '../models/ConfirmAlarmRequest';
import {
    type ControlCallInput,
    ControlCallInputFromJSON,
    ControlCallInputToJSON,
} from '../models/ControlCallInput';
import {
    type ControlCallResult,
    ControlCallResultFromJSON,
    ControlCallResultToJSON,
} from '../models/ControlCallResult';
import {
    type ControlWriteInput,
    ControlWriteInputFromJSON,
    ControlWriteInputToJSON,
} from '../models/ControlWriteInput';
import {
    type ControlWriteResult,
    ControlWriteResultFromJSON,
    ControlWriteResultToJSON,
} from '../models/ControlWriteResult';
import {
    type MethodInfo,
    MethodInfoFromJSON,
    MethodInfoToJSON,
} from '../models/MethodInfo';
import {
    type OrganizedFunctionalUnit,
    OrganizedFunctionalUnitFromJSON,
    OrganizedFunctionalUnitToJSON,
} from '../models/OrganizedFunctionalUnit';
import {
    type OrganizedFunctionalUnitInput,
    OrganizedFunctionalUnitInputFromJSON,
    OrganizedFunctionalUnitInputToJSON,
} from '../models/OrganizedFunctionalUnitInput';
import {
    type RemoveOverride200Response,
    RemoveOverride200ResponseFromJSON,
    RemoveOverride200ResponseToJSON,
} from '../models/RemoveOverride200Response';
import {
    type ReportAlarmRequest,
    ReportAlarmRequestFromJSON,
    ReportAlarmRequestToJSON,
} from '../models/ReportAlarmRequest';
import {
    type ResetAlarmRequest,
    ResetAlarmRequestFromJSON,
    ResetAlarmRequestToJSON,
} from '../models/ResetAlarmRequest';
import {
    type SetAlarmLatchedRequest,
    SetAlarmLatchedRequestFromJSON,
    SetAlarmLatchedRequestToJSON,
} from '../models/SetAlarmLatchedRequest';
import {
    type UAFunction,
    UAFunctionFromJSON,
    UAFunctionToJSON,
} from '../models/UAFunction';
import {
    type UALADSDevice,
    UALADSDeviceFromJSON,
    UALADSDeviceToJSON,
} from '../models/UALADSDevice';
import {
    type UALADSFunctionalUnit,
    UALADSFunctionalUnitFromJSON,
    UALADSFunctionalUnitToJSON,
} from '../models/UALADSFunctionalUnit';
import {
    type ValueOverride,
    ValueOverrideFromJSON,
    ValueOverrideToJSON,
} from '../models/ValueOverride';
import {
    type ValueOverrideInput,
    ValueOverrideInputFromJSON,
    ValueOverrideInputToJSON,
} from '../models/ValueOverrideInput';

export interface AckAlarmOperationRequest {
    /**
     * Stable incident id (SHA-1 of the source node id)
     */
    incidentId: string;
    /**
     * 
     */
    ackAlarmRequest?: AckAlarmRequest;
}

export interface ConfirmAlarmOperationRequest {
    /**
     * 
     */
    incidentId: string;
    /**
     * 
     */
    confirmAlarmRequest?: ConfirmAlarmRequest;
}

export interface ControlCallRequest {
    controlCallInput: ControlCallInput;
}

export interface ControlWriteRequest {
    controlWriteInput: ControlWriteInput;
}

export interface CreateOrganizedFunctionalUnitRequest {
    /**
     * 
     */
    organizedFunctionalUnitInput: OrganizedFunctionalUnitInput;
}

export interface DeleteAlarmMonitorRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
    /**
     * browsename of the function
     */
    functionId: string;
}

export interface DeleteOrganizedFunctionalUnitRequest {
    /**
     * Browse path of the source FunctionalUnit
     */
    sourceBrowsePath: string;
    /**
     * Browse path of the target FunctionalUnitSet
     */
    targetBrowsePath: string;
}

export interface GetBinaryRequest {
    /**
     * URL-encoded OPC UA NodeId of the binary variable
     */
    nodeId: string;
}

export interface GetDeviceRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
}

export interface GetDeviceMethodsRequest {
    deviceId: string;
}

export interface GetDevicesRequest {
    /**
     * filter device for the hirarchical location attribute
     */
    hierarchicalLocation?: string;
}

export interface GetFunctionRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
    /**
     * browsename of the function
     */
    functionId: string;
}

export interface GetFunctionalUnitRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
}

export interface GetFunctionalUnitsRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
}

export interface GetFunctionsRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
}

export interface GetOrganizedFunctionalUnitsRequest {
    /**
     * Optional filter by target FunctionalUnitSet browse path
     */
    targetBrowsePath?: string;
}

export interface RemoveOverrideRequest {
    /**
     * The browse path of the override to remove
     */
    browsePath: string;
}

export interface ReportAlarmOperationRequest {
    /**
     * 
     */
    incidentId: string;
    /**
     * 
     */
    reportAlarmRequest?: ReportAlarmRequest;
}

export interface ResetAlarmOperationRequest {
    /**
     * 
     */
    incidentId: string;
    /**
     * 
     */
    resetAlarmRequest?: ResetAlarmRequest;
}

export interface SetAlarmLatchedOperationRequest {
    /**
     * 
     */
    incidentId: string;
    /**
     * 
     */
    setAlarmLatchedRequest: SetAlarmLatchedRequest;
}

export interface SetOverrideRequest {
    /**
     * 
     */
    valueOverrideInput: ValueOverrideInput;
}

export interface UpdateAlarmMonitorRequest {
    /**
     * browsename of the device
     */
    deviceId: string;
    /**
     * browsename of the functionalUnit
     */
    functionalUnitId: string;
    /**
     * browsename of the function
     */
    functionId: string;
    /**
     * 
     */
    alarmMonitorSettings: AlarmMonitorSettings;
}

/**
 * 
 */
export class LADSApi extends runtime.BaseAPI {

    /**
     * Creates request options for ackAlarm without sending the request
     */
    async ackAlarmRequestOpts(requestParameters: AckAlarmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling ackAlarm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/alarms/{incidentId}/ack`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AckAlarmRequestToJSON(requestParameters['ackAlarmRequest']),
        };
    }

    /**
     * Resolves the incidentId (stable hash) to its OPC UA source node and raises an AuditConditionAcknowledgeEventType on it. The historian persists the event, which flips the IncidentsService state-fold to ACKNOWLEDGED on next read. 
     * Acknowledge an alarm incident
     */
    async ackAlarmRaw(requestParameters: AckAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.ackAlarmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resolves the incidentId (stable hash) to its OPC UA source node and raises an AuditConditionAcknowledgeEventType on it. The historian persists the event, which flips the IncidentsService state-fold to ACKNOWLEDGED on next read. 
     * Acknowledge an alarm incident
     */
    async ackAlarm(requestParameters: AckAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.ackAlarmRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for confirmAlarm without sending the request
     */
    async confirmAlarmRequestOpts(requestParameters: ConfirmAlarmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling confirmAlarm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/alarms/{incidentId}/confirm`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmAlarmRequestToJSON(requestParameters['confirmAlarmRequest']),
        };
    }

    /**
     * Raises an AuditConditionConfirmEventType on the alarm\'s source node. State-fold flips to CONFIRMED. 
     * Confirm an alarm incident (follow-up to acknowledge)
     */
    async confirmAlarmRaw(requestParameters: ConfirmAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.confirmAlarmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Raises an AuditConditionConfirmEventType on the alarm\'s source node. State-fold flips to CONFIRMED. 
     * Confirm an alarm incident (follow-up to acknowledge)
     */
    async confirmAlarm(requestParameters: ConfirmAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmAlarmRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for controlCall without sending the request
     */
    async controlCallRequestOpts(requestParameters: ControlCallRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['controlCallInput'] == null) {
            throw new runtime.RequiredError(
                'controlCallInput',
                'Required parameter "controlCallInput" was null or undefined when calling controlCall().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Devices.Write"]);
        }


        let urlPath = `/lads/control-call`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlCallInputToJSON(requestParameters['controlCallInput']),
        };
    }

    /**
     * Call a reconstructed method through to the real device. The call runs on the source server, which returns the StatusCode and output arguments. 
     */
    async controlCallRaw(requestParameters: ControlCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlCallResult>> {
        const requestOptions = await this.controlCallRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlCallResultFromJSON(jsonValue));
    }

    /**
     * Call a reconstructed method through to the real device. The call runs on the source server, which returns the StatusCode and output arguments. 
     */
    async controlCall(requestParameters: ControlCallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlCallResult> {
        const response = await this.controlCallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for controlWrite without sending the request
     */
    async controlWriteRequestOpts(requestParameters: ControlWriteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['controlWriteInput'] == null) {
            throw new runtime.RequiredError(
                'controlWriteInput',
                'Required parameter "controlWriteInput" was null or undefined when calling controlWrite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Devices.Write"]);
        }


        let urlPath = `/lads/control-write`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlWriteInputToJSON(requestParameters['controlWriteInput']),
        };
    }

    /**
     * Write a control-function TargetValue through to the real device. Unlike /override (proxy-local), the write is forwarded to the source server and the real StatusCode is returned (e.g. 403 for a read-only node). 
     */
    async controlWriteRaw(requestParameters: ControlWriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlWriteResult>> {
        const requestOptions = await this.controlWriteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlWriteResultFromJSON(jsonValue));
    }

    /**
     * Write a control-function TargetValue through to the real device. Unlike /override (proxy-local), the write is forwarded to the source server and the real StatusCode is returned (e.g. 403 for a read-only node). 
     */
    async controlWrite(requestParameters: ControlWriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlWriteResult> {
        const response = await this.controlWriteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrganizedFunctionalUnit without sending the request
     */
    async createOrganizedFunctionalUnitRequestOpts(requestParameters: CreateOrganizedFunctionalUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organizedFunctionalUnitInput'] == null) {
            throw new runtime.RequiredError(
                'organizedFunctionalUnitInput',
                'Required parameter "organizedFunctionalUnitInput" was null or undefined when calling createOrganizedFunctionalUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/organized-functional-unit`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizedFunctionalUnitInputToJSON(requestParameters['organizedFunctionalUnitInput']),
        };
    }

    /**
     * Creates an OPC UA \"Organizes\" reference so that a FunctionalUnit from one device appears in another device\'s FunctionalUnitSet. Example: FreezerUnit from FreezerDevice@0815 is organized by myViscometer@4711\'s FunctionalUnitSet. 
     */
    async createOrganizedFunctionalUnitRaw(requestParameters: CreateOrganizedFunctionalUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizedFunctionalUnit>> {
        const requestOptions = await this.createOrganizedFunctionalUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizedFunctionalUnitFromJSON(jsonValue));
    }

    /**
     * Creates an OPC UA \"Organizes\" reference so that a FunctionalUnit from one device appears in another device\'s FunctionalUnitSet. Example: FreezerUnit from FreezerDevice@0815 is organized by myViscometer@4711\'s FunctionalUnitSet. 
     */
    async createOrganizedFunctionalUnit(requestParameters: CreateOrganizedFunctionalUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizedFunctionalUnit> {
        const response = await this.createOrganizedFunctionalUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAlarmMonitor without sending the request
     */
    async deleteAlarmMonitorRequestOpts(requestParameters: DeleteAlarmMonitorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling deleteAlarmMonitor().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling deleteAlarmMonitor().'
            );
        }

        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling deleteAlarmMonitor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/FunctionalUnitSet/{functionalUnitId}/FunctionSet/{functionId}/alarmMonitor`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));
        urlPath = urlPath.replace('{functionId}', encodeURIComponent(String(requestParameters['functionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Removes user-defined alarm monitor settings for a Function
     */
    async deleteAlarmMonitorRaw(requestParameters: DeleteAlarmMonitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAlarmMonitorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes user-defined alarm monitor settings for a Function
     */
    async deleteAlarmMonitor(requestParameters: DeleteAlarmMonitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAlarmMonitorRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteOrganizedFunctionalUnit without sending the request
     */
    async deleteOrganizedFunctionalUnitRequestOpts(requestParameters: DeleteOrganizedFunctionalUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceBrowsePath'] == null) {
            throw new runtime.RequiredError(
                'sourceBrowsePath',
                'Required parameter "sourceBrowsePath" was null or undefined when calling deleteOrganizedFunctionalUnit().'
            );
        }

        if (requestParameters['targetBrowsePath'] == null) {
            throw new runtime.RequiredError(
                'targetBrowsePath',
                'Required parameter "targetBrowsePath" was null or undefined when calling deleteOrganizedFunctionalUnit().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sourceBrowsePath'] != null) {
            queryParameters['sourceBrowsePath'] = requestParameters['sourceBrowsePath'];
        }

        if (requestParameters['targetBrowsePath'] != null) {
            queryParameters['targetBrowsePath'] = requestParameters['targetBrowsePath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/organized-functional-unit`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Soft-deletes an organized FunctionalUnit mapping
     */
    async deleteOrganizedFunctionalUnitRaw(requestParameters: DeleteOrganizedFunctionalUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveOverride200Response>> {
        const requestOptions = await this.deleteOrganizedFunctionalUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemoveOverride200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft-deletes an organized FunctionalUnit mapping
     */
    async deleteOrganizedFunctionalUnit(requestParameters: DeleteOrganizedFunctionalUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveOverride200Response> {
        const response = await this.deleteOrganizedFunctionalUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBinary without sending the request
     */
    async getBinaryRequestOpts(requestParameters: GetBinaryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling getBinary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/binary/{nodeId}`;
        urlPath = urlPath.replace('{nodeId}', encodeURIComponent(String(requestParameters['nodeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Streams the raw ByteString value of the variable identified by nodeId. The Content-Type is derived from the variable\'s OPC UA data type (ImagePNG → image/png, ImageJPG → image/jpeg, ImageGIF → image/gif, ImageBMP → image/bmp, otherwise application/octet-stream). The response carries a Content-Disposition filename taken from the variable\'s BrowseName so the browser stores it under the correct name.
     * Download a binary OPC UA variable (e.g. a DeviceTypeImage file)
     */
    async getBinaryRaw(requestParameters: GetBinaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.getBinaryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Streams the raw ByteString value of the variable identified by nodeId. The Content-Type is derived from the variable\'s OPC UA data type (ImagePNG → image/png, ImageJPG → image/jpeg, ImageGIF → image/gif, ImageBMP → image/bmp, otherwise application/octet-stream). The response carries a Content-Disposition filename taken from the variable\'s BrowseName so the browser stores it under the correct name.
     * Download a binary OPC UA variable (e.g. a DeviceTypeImage file)
     */
    async getBinary(requestParameters: GetBinaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBinaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDevice without sending the request
     */
    async getDeviceRequestOpts(requestParameters: GetDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns Device details (deviceIds are suffixed with serverId)
     */
    async getDeviceRaw(requestParameters: GetDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UALADSDevice>> {
        const requestOptions = await this.getDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UALADSDeviceFromJSON(jsonValue));
    }

    /**
     * Returns Device details (deviceIds are suffixed with serverId)
     */
    async getDevice(requestParameters: GetDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UALADSDevice> {
        const response = await this.getDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeviceMethods without sending the request
     */
    async getDeviceMethodsRequestOpts(requestParameters: GetDeviceMethodsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getDeviceMethods().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Devices.Read"]);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/methods`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the reconstructed, callable methods of a device (browsed from the device subtree), with their input/output argument metadata. Call one via POST /control-call using the returned browsePath. 
     */
    async getDeviceMethodsRaw(requestParameters: GetDeviceMethodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MethodInfo>>> {
        const requestOptions = await this.getDeviceMethodsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MethodInfoFromJSON));
    }

    /**
     * List the reconstructed, callable methods of a device (browsed from the device subtree), with their input/output argument metadata. Call one via POST /control-call using the returned browsePath. 
     */
    async getDeviceMethods(requestParameters: GetDeviceMethodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MethodInfo>> {
        const response = await this.getDeviceMethodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDevices without sending the request
     */
    async getDevicesRequestOpts(requestParameters: GetDevicesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['hierarchicalLocation'] != null) {
            queryParameters['hierarchicalLocation'] = requestParameters['hierarchicalLocation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns global DeviceSet (deviceIds are suffixed with serverId)
     */
    async getDevicesRaw(requestParameters: GetDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UALADSDevice>>> {
        const requestOptions = await this.getDevicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UALADSDeviceFromJSON));
    }

    /**
     * Returns global DeviceSet (deviceIds are suffixed with serverId)
     */
    async getDevices(requestParameters: GetDevicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UALADSDevice>> {
        const response = await this.getDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFunction without sending the request
     */
    async getFunctionRequestOpts(requestParameters: GetFunctionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getFunction().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling getFunction().'
            );
        }

        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling getFunction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/FunctionalUnitSet/{functionalUnitId}/FunctionSet/{functionId}`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));
        urlPath = urlPath.replace('{functionId}', encodeURIComponent(String(requestParameters['functionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns Function details
     */
    async getFunctionRaw(requestParameters: GetFunctionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UAFunction>> {
        const requestOptions = await this.getFunctionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UAFunctionFromJSON(jsonValue));
    }

    /**
     * Returns Function details
     */
    async getFunction(requestParameters: GetFunctionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UAFunction> {
        const response = await this.getFunctionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFunctionalUnit without sending the request
     */
    async getFunctionalUnitRequestOpts(requestParameters: GetFunctionalUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getFunctionalUnit().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling getFunctionalUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/FunctionalUnitSet/{functionalUnitId}`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns FunctionalUnitSet details
     */
    async getFunctionalUnitRaw(requestParameters: GetFunctionalUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UALADSFunctionalUnit>> {
        const requestOptions = await this.getFunctionalUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UALADSFunctionalUnitFromJSON(jsonValue));
    }

    /**
     * Returns FunctionalUnitSet details
     */
    async getFunctionalUnit(requestParameters: GetFunctionalUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UALADSFunctionalUnit> {
        const response = await this.getFunctionalUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFunctionalUnits without sending the request
     */
    async getFunctionalUnitsRequestOpts(requestParameters: GetFunctionalUnitsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getFunctionalUnits().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/FunctionalUnitSet`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns FunctionalUnitSet of device
     */
    async getFunctionalUnitsRaw(requestParameters: GetFunctionalUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UALADSFunctionalUnit>>> {
        const requestOptions = await this.getFunctionalUnitsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UALADSFunctionalUnitFromJSON));
    }

    /**
     * Returns FunctionalUnitSet of device
     */
    async getFunctionalUnits(requestParameters: GetFunctionalUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UALADSFunctionalUnit>> {
        const response = await this.getFunctionalUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFunctions without sending the request
     */
    async getFunctionsRequestOpts(requestParameters: GetFunctionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling getFunctions().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling getFunctions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/FunctionalUnitSet/{functionalUnitId}/FunctionSet`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns FunctionSet of FunctionalUnit
     */
    async getFunctionsRaw(requestParameters: GetFunctionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UAFunction>>> {
        const requestOptions = await this.getFunctionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UAFunctionFromJSON));
    }

    /**
     * Returns FunctionSet of FunctionalUnit
     */
    async getFunctions(requestParameters: GetFunctionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UAFunction>> {
        const response = await this.getFunctionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganizedFunctionalUnits without sending the request
     */
    async getOrganizedFunctionalUnitsRequestOpts(requestParameters: GetOrganizedFunctionalUnitsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['targetBrowsePath'] != null) {
            queryParameters['targetBrowsePath'] = requestParameters['targetBrowsePath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/organized-functional-units`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all active organized FunctionalUnit mappings
     */
    async getOrganizedFunctionalUnitsRaw(requestParameters: GetOrganizedFunctionalUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizedFunctionalUnit>>> {
        const requestOptions = await this.getOrganizedFunctionalUnitsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizedFunctionalUnitFromJSON));
    }

    /**
     * Lists all active organized FunctionalUnit mappings
     */
    async getOrganizedFunctionalUnits(requestParameters: GetOrganizedFunctionalUnitsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizedFunctionalUnit>> {
        const response = await this.getOrganizedFunctionalUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOverrides without sending the request
     */
    async getOverridesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/overrides`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all value overrides
     */
    async getOverridesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ValueOverride>>> {
        const requestOptions = await this.getOverridesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ValueOverrideFromJSON));
    }

    /**
     * Lists all value overrides
     */
    async getOverrides(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ValueOverride>> {
        const response = await this.getOverridesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeOverride without sending the request
     */
    async removeOverrideRequestOpts(requestParameters: RemoveOverrideRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['browsePath'] == null) {
            throw new runtime.RequiredError(
                'browsePath',
                'Required parameter "browsePath" was null or undefined when calling removeOverride().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['browsePath'] != null) {
            queryParameters['browsePath'] = requestParameters['browsePath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/override`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Removes a value override
     */
    async removeOverrideRaw(requestParameters: RemoveOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveOverride200Response>> {
        const requestOptions = await this.removeOverrideRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemoveOverride200ResponseFromJSON(jsonValue));
    }

    /**
     * Removes a value override
     */
    async removeOverride(requestParameters: RemoveOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveOverride200Response> {
        const response = await this.removeOverrideRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportAlarm without sending the request
     */
    async reportAlarmRequestOpts(requestParameters: ReportAlarmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling reportAlarm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/alarms/{incidentId}/report`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportAlarmRequestToJSON(requestParameters['reportAlarmRequest']),
        };
    }

    /**
     * Raises an AuditConditionReportedEventType (Essentim companion spec, ns=…;i=15001) on the alarm\'s source node. Independent of Ack and Confirm — represents an escalation/notification step in the operator workflow. State-fold flips to REPORTED. 
     * Report an alarm incident (escalation, distinct from Ack)
     */
    async reportAlarmRaw(requestParameters: ReportAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.reportAlarmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Raises an AuditConditionReportedEventType (Essentim companion spec, ns=…;i=15001) on the alarm\'s source node. Independent of Ack and Confirm — represents an escalation/notification step in the operator workflow. State-fold flips to REPORTED. 
     * Report an alarm incident (escalation, distinct from Ack)
     */
    async reportAlarm(requestParameters: ReportAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reportAlarmRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for resetAlarm without sending the request
     */
    async resetAlarmRequestOpts(requestParameters: ResetAlarmOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling resetAlarm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/alarms/{incidentId}/reset`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetAlarmRequestToJSON(requestParameters['resetAlarmRequest']),
        };
    }

    /**
     * Calls the Reset (or Reset2 if comment provided) method on the alarm\'s OPC UA condition node. Clears LatchedState and re-evaluates the input; the alarm transitions to inactive when the underlying condition is gone, otherwise it stays active. 
     * Reset a latched alarm
     */
    async resetAlarmRaw(requestParameters: ResetAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.resetAlarmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Calls the Reset (or Reset2 if comment provided) method on the alarm\'s OPC UA condition node. Clears LatchedState and re-evaluates the input; the alarm transitions to inactive when the underlying condition is gone, otherwise it stays active. 
     * Reset a latched alarm
     */
    async resetAlarm(requestParameters: ResetAlarmOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetAlarmRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for setAlarmLatched without sending the request
     */
    async setAlarmLatchedRequestOpts(requestParameters: SetAlarmLatchedOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling setAlarmLatched().'
            );
        }

        if (requestParameters['setAlarmLatchedRequest'] == null) {
            throw new runtime.RequiredError(
                'setAlarmLatchedRequest',
                'Required parameter "setAlarmLatchedRequest" was null or undefined when calling setAlarmLatched().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/alarms/{incidentId}/latched`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SetAlarmLatchedRequestToJSON(requestParameters['setAlarmLatchedRequest']),
        };
    }

    /**
     * Sets the LatchedState (TwoStateVariable). When TRUE, the alarm cannot deactivate until the next Reset call. When FALSE, normal active/ inactive transitions resume. 
     * Toggle the LatchedState property of an alarm
     */
    async setAlarmLatchedRaw(requestParameters: SetAlarmLatchedOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setAlarmLatchedRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets the LatchedState (TwoStateVariable). When TRUE, the alarm cannot deactivate until the next Reset call. When FALSE, normal active/ inactive transitions resume. 
     * Toggle the LatchedState property of an alarm
     */
    async setAlarmLatched(requestParameters: SetAlarmLatchedOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setAlarmLatchedRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for setOverride without sending the request
     */
    async setOverrideRequestOpts(requestParameters: SetOverrideRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['valueOverrideInput'] == null) {
            throw new runtime.RequiredError(
                'valueOverrideInput',
                'Required parameter "valueOverrideInput" was null or undefined when calling setOverride().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/override`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValueOverrideInputToJSON(requestParameters['valueOverrideInput']),
        };
    }

    /**
     * Sets a value override on any OPC UA browse path
     */
    async setOverrideRaw(requestParameters: SetOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValueOverride>> {
        const requestOptions = await this.setOverrideRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValueOverrideFromJSON(jsonValue));
    }

    /**
     * Sets a value override on any OPC UA browse path
     */
    async setOverride(requestParameters: SetOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValueOverride> {
        const response = await this.setOverrideRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAlarmMonitor without sending the request
     */
    async updateAlarmMonitorRequestOpts(requestParameters: UpdateAlarmMonitorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling updateAlarmMonitor().'
            );
        }

        if (requestParameters['functionalUnitId'] == null) {
            throw new runtime.RequiredError(
                'functionalUnitId',
                'Required parameter "functionalUnitId" was null or undefined when calling updateAlarmMonitor().'
            );
        }

        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling updateAlarmMonitor().'
            );
        }

        if (requestParameters['alarmMonitorSettings'] == null) {
            throw new runtime.RequiredError(
                'alarmMonitorSettings',
                'Required parameter "alarmMonitorSettings" was null or undefined when calling updateAlarmMonitor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/lads/DeviceSet/{deviceId}/FunctionalUnitSet/{functionalUnitId}/FunctionSet/{functionId}/alarmMonitor`;
        urlPath = urlPath.replace('{deviceId}', encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace('{functionalUnitId}', encodeURIComponent(String(requestParameters['functionalUnitId'])));
        urlPath = urlPath.replace('{functionId}', encodeURIComponent(String(requestParameters['functionId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AlarmMonitorSettingsToJSON(requestParameters['alarmMonitorSettings']),
        };
    }

    /**
     * Updates alarm monitor settings for a Function
     */
    async updateAlarmMonitorRaw(requestParameters: UpdateAlarmMonitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UAFunction>> {
        const requestOptions = await this.updateAlarmMonitorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UAFunctionFromJSON(jsonValue));
    }

    /**
     * Updates alarm monitor settings for a Function
     */
    async updateAlarmMonitor(requestParameters: UpdateAlarmMonitorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UAFunction> {
        const response = await this.updateAlarmMonitorRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
